import {IhbarnameAlacakHacziEntity} from "@/entity/Haciz/IhbarnameAlacakHacziEntity";
export class SeksenDokuzTebligatEntity extends IhbarnameAlacakHacziEntity{
    ihbarnamenin_gonderildigi_tarih!: Date
    ihbarnamenin_teblig_tarihi!: Date
    barkod_no!: number;
    itiraz_var_mi: boolean = false;
    itiraz_tarihi!: Date;
}